export default __webpack_public_path__ + "assets/serving-drink.03d5cef3.svg";